// shared/ui/z-index.ts
export const Z_STACK_BASE = 2_147_483_000; // debajo del máximo 32-bit
export const Z_MODAL = Z_STACK_BASE + 10;
export const Z_TOAST = Z_STACK_BASE + 20; // > modal
export const Z_OVERLAY = Z_STACK_BASE + 5; // si quieres separar overlay
